import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ILanguage } from './app';
import type { ExpressionKey } from '../consts/language/en';

const languageImports: Record<ILanguage, () => Promise<Record<ExpressionKey, string>>> = {
    sv: () => import('../consts/language/sv').then((m) => m.expressionsSv),
    no: () => import('../consts/language/no').then((m) => m.expressionsNo),
    en: () => import('../consts/language/en').then((m) => m.expressionsEn),
    da: () => import('../consts/language/da').then((m) => m.expressionsDa),
    fi: () => import('../consts/language/fi').then((m) => m.expressionsFi),
};

const useExpressionStore = defineStore('expression', () => {
    const expressions = ref<Partial<Record<ExpressionKey, string>>>({});

    const getExpressions = async (language: ILanguage) => {
        expressions.value = await languageImports[language]();
    };

    return { expressions, getExpressions };
});

const __ = (key: ExpressionKey, placeholders: Record<string, string> | null = null): string => {
    const store = useExpressionStore();
    let str = store.expressions[key] || `[${key}]`;

    if (placeholders) {
        for (const [placeholder, value] of Object.entries(placeholders)) {
            const regex = new RegExp(`:{0,1}{${placeholder}}`, 'g');
            // A replacer function keeps a $ sequence inside the value from expanding as a match reference.
            str = str.replace(regex, () => value);
        }
    }

    return str;
};

const __untypedExpression = (
    key: string,
    placeholders: Record<string, string> | null = null
): string => {
    return __(key as ExpressionKey, placeholders);
};

const hasExpression = (key: string): boolean => {
    const store = useExpressionStore();
    return Object.hasOwn(store.expressions, key);
};

export { useExpressionStore, __, __untypedExpression, hasExpression };
